export const priorityStrategies = [
	{
		value: '',
		label: '',
		translateKey:
			'VIEWS.USER_BOARD.PRESETS.DIALOG.CONTENT.PRIORITY_STRATEGY.OPTIONS.NONE',
	},
	{
		value: 'mean_bitrate',
		label: 'Mean Bitrate',
		translateKey:
			'VIEWS.USER_BOARD.PRESETS.DIALOG.CONTENT.PRIORITY_STRATEGY.OPTIONS.MEAN_VIDEO_BITRATE',
	},
	{
		value: 'size',
		label: 'Size',
		translateKey:
			'VIEWS.USER_BOARD.PRESETS.DIALOG.CONTENT.PRIORITY_STRATEGY.OPTIONS.SIZE',
	},
];
